import { render } from "./vcoupondata.vue?vue&type=template&id=a4d36f4c&scoped=true"
import script from "./vcoupondata.vue?vue&type=script&lang=js"
export * from "./vcoupondata.vue?vue&type=script&lang=js"

import "./vcoupondata.vue?vue&type=style&index=0&id=a4d36f4c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d36f4c"]])

export default __exports__